export default {
  title: "",
  subtitle: "Transaction Details",
  path: "transactions_details",
  paragraph: "To check the details of a transaction, who paid, the value, the ids, date of payment, currency and more, you can check this endpoint, use the id of the transaction to receive all the information: ",
  request: {
    method: "GET",
    endpoint: "/transactions/:id" ,
		responses: {
			"data": {
				"value": "500.00",
				"currency": "USD",
				"to_bank_account": {
					"owner_name": "Daniels de Paolo",
					"owner_document_number": "01010101099",
					"owner_company": {
						"social_name": "Dagny Taggart",
						"id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
						"document_type": "passport",
						"document_number": "J83579487346"
					},
					"intermediary_bank_account": null,
					"id": "9fbdea6a-40a7-463c-9912-bb737e2d9722",
					"currency": "BRL",
					"branch_number": "5198",
					"bank": {
						"id": "f9dcd833-a4a8-4595-8f5a-b63b0a98292d",
						"code": "031",
						"name": "Banco do Estado de Minas Gerais",
						"switf": null,
						"ispb": null
					},
					"account_type": "conta-corrente",
					"account_number": "04378-9"
				},
				"subject_is_receiver": false,
				"subject_id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
				"subject": {
					"id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
					"social_name": "Dagny Taggart",
					"document_type": "passport",
					"document_number": "J83579487346",
					"status": "approved",
					"required_clearance_level": 1,
					"email": null,
					"clearance_level": 1,
					"birth_date": "1965-04-06",
					"address_street": "Sherman Ave",
					"address_state": "DC",
					"address_postal_code": "12394",
					"address_number": "2252",
					"address_country": "US",
					"address_complement": "Apt 101",
					"address_city": "Washington",
					"references": [],
					"phone_number": null,
					"net_monthly_average_income": "15000.00",
					"inserted_at": "2021-03-08T19:56:22.628081",
					"updated_at": "2021-04-29T22:15:10.988964",
					"fiscal_country": "Brasil"
				},
				"status": "wired",
				"source_name": "Dagny Taggart",
				"source_document_type": "passport",
				"source_document_number": "J83579487346",
				"inserted_at": "2021-04-29T22:21:38.938318",
				"id": "6da07cf4-1ea2-4c92-bb0d-b690b067dad6",
				"from_credit_card": null,
				"from_bank_account": {
					"id": "74b66fcf-5b16-473e-8eb3-3ef5d2f74036",
					"owner_name": "FACILITA FX MERCANTIL FINANCEIRO LTDA",
					"owner_document_number": null,
					"currency": "USD",
					"bank": {
						"id": "292c1958-4926-4c7d-8550-6ce9c0952552",
						"swift": "PLURBRRJ",
						"name": "BRASIL PLURAL S.A. BANCO MÚLTIPLO"
					},
					"account_type": "conta-corrente",
					"account_number": "8901304468"
				},
				"for_exchange": true,
				"exchange_currency": "BRL",
				"exchanged_value": "2688.08",
				"exchange_under_request": false,
				"estimated_value_until_exchange": false,
				"cleared": true,
				"bank_transaction": {
					"id": "2c7d55ee-42b3-438d-94e3-37421f7699cd",
					"value": "500.00",
					"currency": "USD",
					"exchange_currency": "BRL",
					"exchanged_value": "2688.08",
					"exchange_approved": true,
					"exchange_rate": "5.37716",
					"exchange_id": "b5ac2b57-b3bd-4688-bdc4-174cf90192fc",
					"source_type": "TED",
					"source_name": "Dagny Taggart",
					"source_id": "6da07cf4-1ea2-4c92-bb0d-b690b067dad6",
					"source_document_type": "passport",
					"source_document_number": "J83579487346",
					"source_description": "CREDITO POR TED",
					"source_branch": null,
					"source_bank": null,
					"source_account": null,
					"movement_date": "2021-04-29",
					"iof_value": "11.13",
					"inserted_at": "2021-04-29T22:21:38.955717",
					"wire_id": "0ee860fd-67aa-4887-81dd-b2a754638504"
				}
			}
		}
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Transaction UUID"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionDetails.js